module.exports = __webpack_public_path__ + "static/media/2013_nov_met_min.9b182df1.jpg";